import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { Flip, toast, Zoom } from "react-toastify";
import { getHandoverList, postHandover, putHandover, getHandoverDetails } from "../api/handoverAPI";

const initialState = {
  payload: {
    status: null,
    error: null,
    data: null,
  },
  post: {
    status: null,
    error: null,
    data: null,
  },
  put: {
    status: null,
    error: null,
    data: null,
  },
  get: {
    status: null,
    error: null,
    list: [],
  },
  details: {
    status: null,
    error: null,
    list: [],
  },
};

export const getHandovers = createAsyncThunk("handovers/getHandovers", async (payload, { rejectWithValue }) => {
  try {
    const response = await getHandoverList(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});

export const getHandoversDetails = createAsyncThunk("handovers/getHandoversDetails", async (payload, { rejectWithValue }) => {
  try {
    const response = await getHandoverDetails(payload);
    // console.log('responseresponse',response)
    return response;
  } catch (error) {
    console.log("Error ", error);
    return rejectWithValue(error.message);
  }
});

export const addHandover = createAsyncThunk(
  "handovers/addHandover",
  async (payload, { rejectWithValue }) => {
    try {
      // const response = {
      //   status:201,
      //   data:{}
      // }
      const response = await postHandover(payload);
      return response;
    } catch (err) {
      return rejectWithValue(err.message);
    }
  }
);

export const updateHandover = createAsyncThunk(
  "handovers/updateHandover",
  async (payload, { rejectWithValue }) => {
    try {
      // const response = {
      //   status:201,
      //   data:{}
      // }
      const response = await putHandover(payload);
      return response;
    } catch (err) {
      // console.log('err',err)
      return rejectWithValue(err.message);
    }
  }
);


export const handoversSlice = createSlice({
  name: "expenses",
  initialState: initialState,
  reducers: {
    resetItemsState: (state) => {
      state.post.status = null;
      state.post.data = null;
      state.post.error = null;

      state.payload.data = null;
      state.payload.error = null;
      state.payload.status = null;

      state.put.error = null;
      state.put.data = null;

      state.get.status = null;
      state.get.error = null;
      state.get.list = [];

      state.details.status = null;
      state.details.error = null;
      state.details.list = [];
    },
  },
  extraReducers: {
    [getHandovers.pending]: (state) => {
      state.get.status = "loading";
    },
    [getHandovers.fulfilled]: (state, {payload}) => {
      // console.log('actionaction',payload)
      const { status, data } = payload;
      if (status === 200) {
        state.get.list = data;
        state.get.error = null;
      }else{
        state.get.error = { message: `${status} - An error occurred` };
      }
      state.get.status = 'idle';
    },
    [getHandoversDetails.pending]: (state) => {
      state.details.status = "loading";
    },
    [getHandoversDetails.fulfilled]: (state, {payload}) => {
      // console.log('actionaction',payload)
      const { status, data } = payload;
      if (status === 200) {
        state.details.list = data;
        state.details.error = null;
      }else{
        state.details.error = { message: `${status} - An error occurred` };
      }
      state.details.status = 'idle';
    },
    [addHandover.pending]: (state) => {
      state.post.status = "loading";
    },
    [addHandover.fulfilled]: (state, { payload }) => {
      const { status, data } = payload;
     if (status === 201) {
        toast.success("Shift saved.", {
          autoClose: 1300,
          transition: Flip,
          hideProgressBar: true,
        });
      }else{
        toast.warn("Couldn't add shift!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
      }
      state.post.status = "idle";
      state.post.data = data;
    },
    [addHandover.rejected]: (state, action) => {
      state.post.status = "idle";
      state.post.error = { message: "An error occurred" };
      console.log("***** WORKFLOW ERROR PAYLOAD ******* ", action);
      toast.error("System error couldn't add shift!", {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
    [updateHandover.pending]: (state) => {
      state.put.status = "loading";
    },
    [updateHandover.fulfilled]: (state, {payload}) => {
      const { status, data } = payload;
      if (status === 202) {
        toast.success("Shift updated.", {
          autoClose: 1300,
          transition: Flip,
          hideProgressBar: true,
        });
      }else{
        state.put.error = "Failed"
        toast.warn("Couldn't update shift!", {
          autoClose: 1300,
          hideProgressBar: true,
        });
      }
      state.put.status = "idle";
      // const index = state.findIndex((user) => user.id === action.payload.id);
      // state[index].updated = action.payload.updated;
    },
    [updateHandover.rejected]: (state, action) => {
      state.put.status = "idle";
      state.put.error = { message: "An error occurred" };
      console.log("***** WORKFLOW ERROR PAYLOAD ******* ", action);
      //alert(JSON.stringify(action.error))
      toast.warn(action.error.message, {
        autoClose: 1300,
        hideProgressBar: true,
      });
    },
  },
});

// export const { resetItemsState } = resetItemsState.actions;
export default handoversSlice.reducer;
